import { render, staticRenderFns } from "./clicksForm.vue?vue&type=template&id=fd0c3976&"
import script from "./clicksForm.vue?vue&type=script&lang=js&"
export * from "./clicksForm.vue?vue&type=script&lang=js&"
import style0 from "./clicksForm.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "clicksForm.vue"
export default component.exports